import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationData } from './confirmation-data';
import { interval, Observable } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { AppointmentService } from './appointment.service';
import { IsAppointmentConfirmed } from './IsAppointmentConfirmed';

@Component({
    selector: 'appointment-confirmation-dialog',
    templateUrl: 'appointment.confirmation-dialog.html',
  })
  export class AppointmentConfirmationDialog implements OnInit, OnDestroy {
  
    obs: Observable<IsAppointmentConfirmed>;
    subscriber;
    
    constructor(
      public dialogRef: MatDialogRef<ConfirmationData>,
      @Inject(MAT_DIALOG_DATA) public data:ConfirmationData,
      private appointmentService: AppointmentService) {
          
      }

      ngOnInit(){
        this.obs = interval(2000).pipe(startWith(0), 
        switchMap(() => this.appointmentService.getAppointmentConfirmation(this.data.appointmentId)))
        

      this.subscriber = this.obs.subscribe(result => {
        if (result.isConfirmed){
          console.log(result);
          this.dialogRef.close();
        }
      });
      }
  
    ngOnDestroy() {
      this.subscriber.unsubscribe();
    }

  }